import React from 'react'
import Typography from '@material-ui/core/Typography'
import { FormattedMessage } from 'react-intl'
const RestrictedLabel = () => {
  return (
    <Typography className="italic text-grey-66">
      <FormattedMessage id="subscriber.label.restricted" />
    </Typography>
  )
}

export default RestrictedLabel
